import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { notEmpty } from "@orb-labs/types";
const AttributionContext = createContext(undefined);
export const useAttribution = () => {
    const context = useContext(AttributionContext);
    if (!notEmpty(context)) {
        throw new Error("useAttribution must be used within an AttributionProvider");
    }
    return context;
};
export const AttributionProvider = ({ runtime, children }) => (_jsx(AttributionContext.Provider, { value: runtime, children: children }));
